import { cva } from 'class-variance-authority';
import { KoobInputStars } from '@koob/ui';
import ActiveJobTooltip from '../../../components/ActiveJobTooltip';

const hotelCard = cva(['bg-white border border-l-4 rounded-md py-4 px-4'], {
  variants: {
    selected: {
      true: 'border-l-k-orange',
      false: 'cursor-pointer',
    },
    disabled: {
      true: 'opacity-50 cursor-not-allowed',
    },
  },
});

export default function AllotmentsHotelSelectorItem({
  item,
  isSelected,
  onSelect,
}) {
  const hasActiveJob = item?.hasActiveJob;

  const onClick = () => {
    if (hasActiveJob || !onSelect) {
      return;
    }
    onSelect();
  };

  return (
    <div className="relative">
      <div
        onClick={onClick}
        className={hotelCard({ selected: isSelected, disabled: hasActiveJob })}
      >
        <div className="flex space-x-3 items-center">
          {isSelected ? (
            <i className="fas fa-circle-check text-k-orange" />
          ) : (
            <i className="far fa-circle text-gray-400" />
          )}

          <div className="flex-shrink-0 bg-gray-50 w-12 h-12 rounded-md overflow-hidden">
            {item.image && (
              <img
                src={item.image}
                alt=""
                className="w-full h-full object-cover border-none"
              />
            )}
          </div>

          <div className="truncate">
            <div
              className="font-medium leading-none text-gray-700"
              data-testid={item.name?.split(' ').join('-')}
            >
              {item.name}
            </div>

            <div>
              <KoobInputStars value={item.stars} size="xs" />
            </div>

            {item.description && (
              <div className="text-gray-500 text-xs">{item.description}</div>
            )}
          </div>
        </div>
      </div>

      {hasActiveJob && (
        <div className="absolute top-1/3 right-5">
          <ActiveJobTooltip>
            <i className="far fa-circle-notch text-gray-500 fa-spin text-lg" />
          </ActiveJobTooltip>
        </div>
      )}
    </div>
  );
}
